import { render } from "./quick_filter_settings.vue?vue&type=template&id=80caf036"
import script from "./quick_filter_settings.js?vue&type=script&lang=js"
export * from "./quick_filter_settings.js?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__